// extracted by mini-css-extract-plugin
export default {"checkbox-group":"details_checkbox-group__+B6ov","quill-container":"details_quill-container__eUTXz"};